import styled from "styled-components";

export const IconButton = styled.button<{
    $primary?: boolean;
    $size?: "small" | "medium" | "large";
  }>`
  background-color: ${({ $primary, theme }) => ($primary ? theme.colors.primary : "transparent")};
  color: ${({ $primary, theme }) => ($primary ? "white" : theme.colors.primary)};
  border: ${({ $primary, theme }) => ($primary ? "none" : `2px solid ${theme.colors.primary}`)};
  border-radius: 50%;
  width: ${({ $size }) => ($size === "small" ? "36px" : $size === "large" ? "56px" : "48px")};
  height: ${({ $size }) => ($size === "small" ? "36px" : $size === "large" ? "56px" : "48px")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: ${({ $size }) => ($size === "small" ? "1rem" : $size === "large" ? "1.5rem" : "1.25rem")};

  &:hover {
    background-color: ${({ $primary, theme }) =>
      $primary ? theme.colors.primary : "rgba(5, 0, 26, 0.05)"};
    transform: translateY(-2px);
    box-shadow: ${({ $primary }) => ($primary ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none")};
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(5, 0, 26, 0.3);
  }

  &:disabled {
    background-color: ${({ $primary }) => ($primary ? "#cccccc" : "transparent")};
    border-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

